import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionService } from '../../../../services/session.service';
import { ConfirmationInput } from '../../../../components/confirmation/confirmation.model';
import { StrapiGenericComponentService } from '../../../../services/strapi-generic-component.service';

@Component({
  selector: 'vm-contact-us-shell',
  templateUrl: './contact-us-shell.component.html',
  styleUrls: ['./contact-us-shell.component.scss'],
})
export class ContactUsShellComponent implements OnInit {
  @Input() uid? = 'angular-contact-us-generic'; // angular-contact-us-wifi-max for alt contact us
  @Input() chatbotId? = 'faultsbuttonnew';
  @Input() enableBackLink?: boolean;
  @Input() workflowConstants: any;
  @Input() hasPriorityCall = true;
  @Input() routerLinkText?: string;
  @Input() routerLinkHref?: string;
  @Output() next = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() openSecondaryModal = new EventEmitter();
  confirmationInput: ConfirmationInput;

  constructor(
    private strapiGenericComponentService: StrapiGenericComponentService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    if (this.hasPriorityCall === false) {
      this.fetchContent(false, true);
    } else {
      this.sessionService.getSessionData().subscribe((sessionResponse) => {
        const ivrPriority = sessionResponse?.angularPublicSession?.ivrPriority || false;
        const ivrPriorityIdentified = sessionResponse?.angularPublicSession?.ivrPriorityMethod === 'Account';
        this.fetchContent(ivrPriority, ivrPriorityIdentified);
      });
    }
  }

  onNext(id) {
    this.next.emit(id);
  }

  onBack(e) {
    this.back.emit(e);
  }

  onOpenSecondaryModal() {
    this.openSecondaryModal.emit();
  }

  private fetchContent(ivrPriority: boolean, ivrPriorityIdentified: boolean) {
    this.strapiGenericComponentService
      .fetchContent(this.uid, ivrPriority, ivrPriorityIdentified)
      .subscribe((result) => {
        result.chatbotId = result?.chatbotId || this.chatbotId;
        this.confirmationInput = result;
      });
  }
}
